export default __webpack_public_path__ + "static/media/pattern-5.63b60cd3.jpg";